const FlagES = props => (
	<svg height="28" width="28" viewBox="0 0 200 200" {...props}>
		<rect fill="#fff" width="200" height="200" />
		<rect fill="#4758a9" x="100" width="50" height="50" />
		<rect fill="#8cbae2" width="100" height="31.5" />
		<rect fill="#8cbae2" y="68.5" width="100" height="31.5" />
		<rect fill="#ffce54" x="100" y="100" width="100" height="50" />
		<rect fill="#4758a9" x="100" y="150" width="100" height="25" />
		<rect fill="#ed5565" x="100" y="175" width="100" height="25" />
		<circle fill="#ffce54" cx="50" cy="50" r="10" />
		<rect fill="#57a863" y="100" width="30" height="100" />
		<rect fill="#ed5565" x="70" y="100" width="30" height="100" />
		<path
			fill="#57a863"
			d="M50,165.5c-8.6,0-15.5-6.9-15.5-15.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5c0,6.9,5.6,12.5,12.5,12.5 s12.5-5.6,12.5-12.5c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5C65.5,158.6,58.6,165.5,50,165.5z"
		/>
		<circle fill="#fff" cx="125" cy="25" r="10" />
		<polygon fill="#ed5565" points="150,50 100,50 100,100 150,100 200,100 200,50" />
		<path fill="#d3924c" d="M50,159c-5,0-9-4-9-9s4-9,9-9s9,4,9,9S55,159,50,159z" />
	</svg>
);

export default FlagES;
